// extracted by mini-css-extract-plugin
export default {"options":"iRY_ylh1MzCfBkNSaJH9"};